import React from 'react';

import _ from 'lodash';
import { createIntl, createIntlCache, IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import { getCountryCode } from '../../lendingAPI/lendingAPISelector';
import LoadingPlaceholder from '../../loadingPlaceholder/LoadingPlaceholder';

export const intlCache = createIntlCache();

export class LanguageProvider extends React.PureComponent {
    render() {
        const { isFetching, locale, messages, children } = this.props;

        let messagesLocale = locale;

        const intlProps = createIntl(
            {
                defaultLocale: 'en',
                locale: locale, // TODO: Need to remove brokers message locale to remove IntlConfig error.
                messages: messages[messagesLocale],
                textComponent: 'span'
            },
            intlCache
        );

        const shouldRender = _.isBoolean(isFetching) && !isFetching;
        return shouldRender ? (
            <IntlProvider {...intlProps}>
                {React.Children.only(children)}
            </IntlProvider>
        ) : (
            <LoadingPlaceholder />
        );
    }
}

const locales = {
    uk: 'en',
    de: 'de'
};

const mapStateToProps = (state, ownProps) => {
    const {
        application: { error }
    } = state.fetched;
    const countryCode = getCountryCode(state);
    const isFetching = state.lendingAPI.context?.pending;
    return {
        locale: ownProps.locale || locales[countryCode],
        error,
        isFetching: ownProps.isFetching ?? isFetching
    };
};

/**
 * This component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */
export default connect(mapStateToProps)(LanguageProvider);
